import React, { Component } from "react";
import { Router, Route } from "react-router";

import About from "./About";
import Game from "./Game";
import GameLayout from "./GameLayout";
import GameStarter from "./GameStarter";
import GridGameLayout from "./GridGameLayout";
import Home from "./Home";
import MPicker from "./MPicker";
import Picker from "./Picker";
import TeamColorsDebug from "./TeamColorsDebug";
import appHistory from "./appHistory";

function PickerAdapter(props) {
  return <Picker lobbyCode={props.params.lobbyCode} />;
}

function MPickerAdapter(props) {
  return <MPicker lobbyCode={props.params.lobbyCode} />;
}

function GameAdapter(props) {
  return <Game GameDisplay={GameLayout} lobbyCode={props.params.lobbyCode} />;
}

function MGameAdapter(props) {
  return <Game GameDisplay={GridGameLayout} lobbyCode={props.params.lobbyCode} />;
}

class App extends Component {
  render() {
    return (
      <Router history={appHistory}>
        <Route path="/" component={Home} />
        <Route path="/about" component={About} />
        <Route path="/create/:gameId" component={GameStarter} />
        <Route path="/lobby/:gameId-:lobbyCode" component={PickerAdapter} />
        <Route path="/g/:lobbyCode" component={GameAdapter} />
        <Route path="/gm/:lobbyCode" component={MGameAdapter} />
        <Route path="/m/:lobbyCode" component={MPickerAdapter} />
        <Route path="/_colors" component={TeamColorsDebug} />
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js